(function(){    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.search = {};
    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
	         "search(/)(/:term)" : "showSearch"
        }
    })
    
    /*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
    var API = {
	    showSearch:function(term){
		    //we don't actually trust the user
		    // Allow letters, numbers, spaces, dashes, underscores
		    term = (term)?term.replace(/[^\w\s-]/gi,''):"";
		 	APPS.search.results.show(term);
	    }
    }
    
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})();